export const navigationItems = [
  { label: "Home", path: "/" },
  {
    label: "Pages",
    children: [
      { label: "About Us", path: "/about" },
      { label: "Services", path: "/services" },
      { label: "Franchise Opportunities", path: "/franchise" },
      { label: "Contact", path: "/contact" },
      { label: "Gallery", path: "/gallery" },
      { label: "Meet the Team", path: "/meet-the-team" },
    ],
  },
  { label: "Courses", path: "/course-grid" },
  { label: "Countries", path: "/countries" },
  {
    label: "Partner Institutions",
    children: [
      { label: "Canada", path: "/instructor", countryCode: "CA" },
      { label: "Australia", path: "/instructor-details", countryCode: "AU" },
      { label: "United Kingdom", path: "/instructor-details", countryCode: "GB" },
      { label: "USA", path: "/instructor-details", countryCode: "US" },
      { label: "Hungary", path: "/instructor-details", countryCode: "HU" },
      { label: "Lithuania", path: "/instructor-details", countryCode: "LT" },
      { label: "Poland", path: "/instructor-details", countryCode: "PL" },
      { label: "New Zealand", path: "/instructor-details", countryCode: "NZ" },
    ],
  },
  { label: "English CENTER", path: "/ielts" },
  { label: "SUCCESS STORIES", sectionId: "testimonials" },
  { label: "FAQS", sectionId: "faq" },
];
